import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/payAccount/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/payAccount',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/payAccount',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/payAccount/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/payAccount',
    method: 'get',
    params: {
      id
    }
  })
}
